module.exports = __webpack_public_path__ + "media/configurations/SV_O-X-X-O-b1081f57.png";